export default __webpack_public_path__ + "static/media/resale-flat.da7ebeff.svg";